<template>
  <div class="pt-60 pb-24">
    <div class="text-left container mx-auto">
      <h1 class="custom-heading h-custom-color">Zásady ochrany osobních údajů</h1>
      <p class="p-custom-color custom-paragraph mr-20">
        Poslední aktualizace 18. 10. 2026
      </p>

      <h1 class="custom-heading h-custom-color mt-20">1. Správce a kontakt</h1>
      <p>
        Správcem osobních údajů je HostNow s.r.o., IČO: 21788693,
        DIČ: CZ21788693, se sídlem Třeboňská 530/2, 140 00 Praha 4 - Michle, Česká republika, zapsaná v obchodním rejstříku vedeném Městským
        soudem v Praze, oddíl C, vložka 406087. Ve věcech ochrany osobních údajů
        nás můžete kontaktovat na
        <a class="text-blue-800 hover:underline" href="mailto:info@hostnow.cz">info@hostnow.cz</a>
        nebo prostřednictvím datové schránky 6znwuvh. Zpracování osobních údajů
        se řídí nařízením (EU) 2016/679 (GDPR) a zákonem č. 110/2019 Sb.,
        o zpracování osobních údajů.
      </p>

      <h1 class="custom-heading h-custom-color mt-20">2. Jaké údaje zpracováváme</h1>
      <ol class="list-decimal ml-10">
        <li>
          identifikační a kontaktní údaje, zejména jméno, e-mail, telefonní číslo
          a identifikátor uživatelského účtu;
        </li>
        <li>
          fakturační údaje, zejména obchodní firmu, ulici a číslo, PSČ, město,
          stát, IČO a DIČ;
        </li>
        <li>
          údaje o projektech a službách, zejména doménu, zvolený plán, nastavení,
          historii změn a komunikaci se zákaznickou podporou;
        </li>
        <li>
          údaje o objednávkách a platbách, zejména částku, měnu, sazbu a režim DPH,
          stav platby, číslo objednávky, identifikátor platby GoPay a záznam
          oprávnění k opakovaným platbám;
        </li>
        <li>
          technické a bezpečnostní údaje, zejména IP adresu, user-agent, čas a průběh
          přihlášení, systémové logy a cookies potřebné pro přihlášení a ochranu relace;
        </li>
        <li>
          identifikátor a profilové údaje účtu Discord, pouze pokud uživatel svůj
          účet dobrovolně propojí se službou HostNow.
        </li>
      </ol>
      <p class="mt-3">
        HostNow neukládá celé číslo platební karty, CVC/CVV ani bezpečnostní údaje
        ke kartě. Tyto údaje zadává zákazník přímo do platební brány GoPay.
      </p>

      <h1 class="custom-heading h-custom-color mt-20">3. Účely a právní základy</h1>
      <ol class="list-decimal ml-10">
        <li>
          <strong>Uzavření a plnění smlouvy:</strong> založení a správa účtu,
          poskytování hostingu, správa projektů, zákaznická podpora, objednávky,
          platby a opakované platby podle čl. 6 odst. 1 písm. b) GDPR.
        </li>
        <li>
          <strong>Plnění právních povinností:</strong> vedení účetnictví, správa
          daní a DPH, vyřizování zákonných práv spotřebitele a součinnost s orgány
          veřejné moci podle čl. 6 odst. 1 písm. c) GDPR.
        </li>
        <li>
          <strong>Oprávněné zájmy:</strong> zabezpečení služby, prevence podvodů
          a zneužití, diagnostika chyb, evidence komunikace a ochrana nebo
          uplatnění právních nároků podle čl. 6 odst. 1 písm. f) GDPR.
        </li>
        <li>
          <strong>Souhlas:</strong> pouze u volitelných činností, u kterých je
          souhlas výslovně vyžádán. Souhlas lze kdykoli odvolat, aniž je tím
          dotčena zákonnost zpracování před jeho odvoláním.
        </li>
      </ol>
      <p class="mt-3">
        Potvrzení, že se zákazník seznámil s těmito zásadami, není souhlasem se
        zpracováním osobních údajů. Jsou-li údaje nezbytné pro uzavření smlouvy
        nebo splnění právní povinnosti, bez jejich poskytnutí nemusíme být schopni
        vytvořit účet či objednávku nebo dále poskytovat placenou službu.
      </p>

      <h1 class="custom-heading h-custom-color mt-20">4. Platby a opakované platby</h1>
      <ol class="list-decimal ml-10">
        <li>
          Platby zpracovává společnost GoPay. GoPay získává platební údaje přímo
          od zákazníka a při plnění vlastních regulatorních povinností může vystupovat
          jako samostatný správce. HostNow dostává pouze údaje potřebné k přiřazení
          a ověření platby.
        </li>
        <li>
          U opakované platby uchováváme důkaz oprávnění spojený s konkrétním
          projektem a objednávkou: verzi podmínek, čas, IP adresu, user-agent,
          plán, první a maximální částku, měnu, frekvenci a dobu platnosti oprávnění.
        </li>
        <li>
          Zrušení opakované platby zastaví budoucí platby. Neznamená automatické
          vymazání záznamů, které musíme nebo smíme dále uchovat pro splnění
          právních povinností a ochranu právních nároků.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">5. Příjemci a dodavatelé</h1>
      <p>Údaje zpřístupňujeme pouze v nezbytném rozsahu zejména těmto kategoriím příjemců:</p>
      <ol class="list-decimal ml-10">
        <li>GoPay jako poskytovateli platební brány;</li>
        <li>dodavatelům serverové, databázové, zálohovací a e-mailové infrastruktury;</li>
        <li>poskytovatelům monitorování chyb a bezpečnosti, například Sentry, je-li tato služba zapnuta;</li>
        <li>
          společnosti Discord při dobrovolném propojení účtu a pro interní
          provozní oznámení o platbách v přístupově omezeném kanálu;
        </li>
        <li>odborným poradcům a orgánům veřejné moci, vyžaduje-li to zákon nebo ochrana práv.</li>
      </ol>
      <p class="mt-3">
        Dodavatelé, kteří zpracovávají údaje naším jménem, je smějí používat pouze
        podle našich pokynů a smluvních podmínek. Aktuální informaci o konkrétním
        dodavateli pro dané zpracování poskytneme na žádost.
      </p>

      <h1 class="custom-heading h-custom-color mt-20">6. Předávání mimo EHP</h1>
      <p>
        Někteří techničtí dodavatelé, zejména Discord a Sentry, mohou údaje
        zpracovávat také ve Spojených státech amerických nebo jiné zemi mimo
        Evropský hospodářský prostor. Takové předání uskutečňujeme pouze na základě
        platného mechanismu podle GDPR, zejména rozhodnutí Evropské komise
        o odpovídající ochraně, rámce EU-US Data Privacy Framework nebo
        standardních smluvních doložek.
      </p>

      <h1 class="custom-heading h-custom-color mt-20">7. Doba uchování</h1>
      <ol class="list-decimal ml-10">
        <li>
          Údaje účtu a aktivních služeb uchováváme po dobu trvání smluvního vztahu.
          Po jeho skončení uchováváme pouze údaje potřebné pro níže uvedené účely.
        </li>
        <li>
          Záznam oprávnění k opakovaným platbám uchováváme po dobu jeho platnosti,
          nejméně 12 měsíců po ukončení opakovaných plateb a následně pouze po dobu
          potřebnou k ochraně právních nároků, zpravidla po dobu příslušné promlčecí
          lhůty. Probíhá-li reklamace, chargeback, kontrola nebo spor, záznam
          uchováme do jejich pravomocného skončení.
        </li>
        <li>
          Daňové doklady a nezbytné údaje o uskutečněných platbách uchováváme
          10 let od konce zdaňovacího období, ve kterém se plnění uskutečnilo.
        </li>
        <li>
          Komunikaci se zákaznickou podporou uchováváme zpravidla tři roky od
          uzavření požadavku; déle pouze tehdy, je-li potřebná pro otevřený spor
          nebo splnění právní povinnosti.
        </li>
        <li>
          Provozní a bezpečnostní logy uchováváme pouze po dobu potřebnou pro
          diagnostiku, zabezpečení a šetření incidentů. Poté je vymažeme nebo
          anonymizujeme, nevyžaduje-li další uchování bezpečnostní incident nebo zákon.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">8. Cookies</h1>
      <p>
        Používáme nezbytné cookies pro přihlášení, zachování relace, bezpečnost
        a základní fungování webu. Bez nich nelze řádně provozovat přihlášené části
        služby. Jiné než nezbytné cookies použijeme pouze po získání souhlasu,
        pokud je takový souhlas podle práva vyžadován.
      </p>

      <h1 class="custom-heading h-custom-color mt-20">9. Práva subjektů údajů</h1>
      <p>Za podmínek stanovených GDPR máte právo:</p>
      <ol class="list-decimal ml-10">
        <li>na přístup ke svým osobním údajům a jejich kopii;</li>
        <li>na opravu nepřesných a doplnění neúplných údajů;</li>
        <li>na výmaz údajů, pokud již neexistuje právní důvod pro jejich uchování;</li>
        <li>na omezení zpracování;</li>
        <li>na přenositelnost údajů zpracovávaných automatizovaně na základě smlouvy nebo souhlasu;</li>
        <li>vznést námitku proti zpracování založenému na oprávněném zájmu;</li>
        <li>kdykoli odvolat souhlas, je-li zpracování založeno na souhlasu;</li>
        <li>podat stížnost u dozorového úřadu.</li>
      </ol>
      <p class="mt-3">
        Žádost zašlete na
        <a class="text-blue-800 hover:underline" href="mailto:info@hostnow.cz">info@hostnow.cz</a>.
        Odpovíme bez zbytečného odkladu, zpravidla do jednoho měsíce. Uplatnění
        práv je bezplatné; přiměřený poplatek můžeme požadovat pouze u zjevně
        nedůvodných nebo nepřiměřených, zejména opakovaných žádostí. Před vyřízením
        žádosti můžeme přiměřeně ověřit totožnost žadatele.
      </p>
      <p class="mt-3">
        Dozorovým úřadem je Úřad pro ochranu osobních údajů, Pplk. Sochora 27,
        170 00 Praha 7,
        <a class="text-blue-800 hover:underline" href="https://uoou.gov.cz/" target="_blank" rel="noopener">uoou.gov.cz</a>.
      </p>

      <h1 class="custom-heading h-custom-color mt-20">10. Bezpečnost a změny</h1>
      <p>
        Používáme přiměřená technická a organizační opatření k ochraně údajů před
        neoprávněným přístupem, ztrátou, změnou nebo zveřejněním. Tyto zásady můžeme
        aktualizovat při změně služby, dodavatelů nebo právních požadavků. Aktuální
        znění a datum poslední aktualizace vždy zveřejníme na této stránce.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "GDPR",
  mounted () {
    window.scrollTo(0, 0)
  },
  metaInfo() {
    return {title: "Zásady ochrany osobních údajů"}
  },
}
</script>

<style scoped>
</style>
